<app-navbar></app-navbar>

<main class="main">
  <router-outlet></router-outlet>
</main>

@if (error && error?.code !== 1002 && error?.code !== 5040) {
  <div class="backend-alert-interceptor">
    <app-alert
      [icon]="'assets/icons/error.svg'"
      [title]="'common_unexpected_error_title_web' | translate"
      [titleFontWeight]="'600'"
      [isDescriptionShown]="true"
      [backgroundColor]="'colors-destructive-50'"
      [color]="'colors-destructive-700'"
      [border]="'1px solid var(--colors-destructive-200)'"
      [errorMessage]="
        error?.message || ('common_unexpected_error' | translate)
      ">
    </app-alert>
  </div>
}

@if (isOffline) {
  <app-no-connection></app-no-connection>
}

@if (isMaintenanceMode) {
  <app-maintenance-mode></app-maintenance-mode>
}
<!-- to cash no screen img when go offline -->
<div class="hidden-offline-image">
  <img src="assets/images/not-found/404.svg" />
</div>
